
import {WOW} from '../../../node_modules/wowjs/dist/wow';
new WOW({
  offset: 100,
}).init();

// 1024刷新
let ismobile = $(window).width() > 1024 ? false : true
let checkmobile = $(window).width() > 1024 ? false : true

$(window).resize(function(){
  ismobile = $(window).width() > 1024 ? false : true;
  
  if(checkmobile != ismobile){
    location.reload()
  }
})

// wow类似
let contTopArr = []
$(document).ready(function(){
  isInviewinit()
})
$(document).scroll(function () {
  isInviewScroll()
})

function getcontTopArr(){
  contTopArr = []
  $('[data-scroll]').each(function(index){
    contTopArr.push({
      'el': $(this),
      'top':$(this).offset().top - $(window).height(),
      'h':$(this).outerHeight(),
      'isrepeat': $(this).attr('data-scroll-repeat') == ''? true : false,
      'speed': $(this).attr('data-scroll-speed') ? Number($(this).attr('data-scroll-speed')) : 0,
      'delay': $(this).attr('data-scroll-delay') ? $(this).attr('data-scroll-delay') : 0,
    })
  })
  // console.log(contTopArr)
}
function isInviewinit(){
  getcontTopArr()
  let scroH = $(document).scrollTop();
  $.each(contTopArr,function(index){
    if(this.top < scroH){
      $('[data-scroll]').eq(index).addClass('is-inview')
    }
    if(this.delay){
      $(this.el).css('transition-delay', this.delay )
    }
  })
}
function isInviewScroll(){
  let scroH = $(document).scrollTop();
  let viewH = $(window).height();
  $.each(contTopArr,function(index){
    if(this.isrepeat){
      if(this.top < scroH && this.top + this.h + viewH*(6/5) > scroH){
        $('[data-scroll]').eq(index).addClass('is-inview')
      }else{
        $('[data-scroll]').eq(index).removeClass('is-inview')
      }
    }else{
      if(this.top <= scroH){
        $('[data-scroll]').eq(index).addClass('is-inview')
      }else{
        $('[data-scroll]').eq(index).removeClass('is-inview')
      }
    }

    if(this.speed){
      $(this.el).css('transform','translateY('+ (scroH - this.top - viewH)*this.speed +'px)')
    }
    if(this.delay){
      $(this.el).css('transition-delay', this.delay )
    }
  })
}

$(window).resize(function(){
  getcontTopArr()
})

// 浮动按钮
$('.arrow-cont').on('mousemove', function (e) {
  let $arrow = $(this).find('.arrow')
  let middle = $(window).width() / 2
  let X = e.clientX - $arrow.width() / 2
  let Y = e.clientY - $arrow.height() / 2
  $arrow.css({ 'top': Y + 'px', 'left': X + 'px' });

  if(X <= middle){
    $arrow.find('.iconfont').css('transform','rotate(-90deg)')
  }else{
    $arrow.find('.iconfont').css('transform','rotate(90deg)')
  }
})
$('.arrow-cont').on('mouseenter', function () {
  $(this).find('.arrow').addClass('active')
})
$('.arrow-cont').on('mouseleave', function () {
  $(this).find('.arrow').removeClass('active')
})
$('.arrow-cont').on('mousedown',function(e){
  $(this).find('.arrow').addClass('mousedown')
})
$('.arrow-cont').on('mouseup',function(e){
  $(this).find('.arrow').removeClass('mousedown')
})
